






















































































import $ from 'jquery';
import {Component, Vue} from 'vue-property-decorator';
import MiniTileComp from './MiniTileComp.vue';
import ImageGallery from './ImageGallery.vue'
const depthImageHe = require('../assets/new-cover-piece-hebrew.png');
const depthImageEn = require('../assets/new-cover-piece-english.png');

require('./../modernizr-custom');
require('./../../src/base/extras/all.js');
require('./../../src/base/lib/turn.min.js');

interface ITile {
    code: string;
    name: string;
    images: {
        big: {
            url: string;
        };
        gallery: Array<{ url: string; }>;
    };
}

interface IChunk {
    items: ITile[],
    selected: ITile,
    index: number;
}

@Component({
    components: {
        MiniTileComp,
        ImageGallery
    }
})
export default class AlbumComp extends Vue {
    public itemChunks:IChunk[] = [];

    private json: CatalogInfo = catalogInfo;
    private items: Array<CatalogItem> = this.json.items;
    private catalogCoverImage: string = this.json.catalogCoverImage;

    private currentItem?: ITile | null = null;

    public created() {
        this.prepareChunks();
        this.currentItem = this.items[0];
    }

    public get lang(): 'he' | 'en' {
        return this.isRTL ? 'he' : 'en';
    }

    public get isRTL(): boolean {
        return this.json.isRTL;
    }

    public get arrowFlip(): string {
        return this.json.isRTL ? "arrow-rtl" : "";
    }

    public get bookWidthRtl(): string {
        return this.json.isRTL ? "book-width-rtl" : "";
    }

    public get secondArrowFlip(): string {
        return !this.json.isRTL ? "arrow-rtl" : "";
    }

    public get arrowContainerRtlAndDark(): string {
        var res = this.json.isRTL ? "arrow-container-rtl" : "";
        res += this.json.theme == "dark" ? " dark-arrow" : "";
        res += this.json.theme == "dark" && this.isRTL ? " dark-arrow-container-rtl" : "";
        return res;
    }

    public get coverImageWidth(): string {
        return this.json.isRTL ? "cover-img-rtl" : "";
    }

    private width: number = (window.innerWidth > 1600) && (window.innerHeight > 980) ? 650 :
        (window.innerWidth > 1124) && (window.innerHeight > 790) ? 480 :
            ((window.innerWidth > 870 && window.innerHeight > 550) ? 370 : 220);
    private height: number = this.width * 600 / 480;

    /**
     *
     */
    private get flipbookElement(): JQuery {
        return $(this.$refs.flipbook) as JQuery;
    }

    private leftPage() {
        this.flipbookElement.turn("next");
    }

    private rightPage() {
        this.flipbookElement.turn("previous");
    }

    private hasGallery(item:ITile) {
        return item && item.images.gallery && item.images.gallery.length > 0;
    }

    private debounce(func: Function) {
        let timer: number;
        return function (event: Event) {
            if (timer) clearTimeout(timer);
            timer = setTimeout(func, 50, event);
        };
    }

    private reloadSizes() {
        this.width = ((window.innerWidth > 1600) && (window.innerHeight > 980)) ? 650 :
            ((window.innerWidth > 1124) && (window.innerHeight > 790)) ? 480 :
                ((window.innerWidth > 870 && window.innerHeight > 550) ? 370 : 220);
        this.height = this.width * 600 / 480;
    }

    private reloadFlipbook(flipbook: JQuery) {
        this.reloadSizes();
        flipbook.turn('size', this.width * 2, this.height);
        this.$forceUpdate();
    }


    private loadFlipbook(flipbook: JQuery) {
        this.width = (flipbook.width() as number / 2) as number;
        this.height = flipbook.height() as number;
        flipbook.turn({
            elevation: 50,
            acceleration: true,
            direction: this.json.isRTL ? "rtl" : 'ltr',
            gradients: true,
            autoCenter: true,
            duration: 1000,
            width: this.width * 2,
            height: this.height,
            pages: 4,
            when: {
                turning: (e: Event, page: number) => {
                    const book = $(e.target as Element),
                        pages = book.turn('pages');

                    if (page + 1 >= pages) {
                        e.preventDefault();
                        return;
                    }

                    if (page >= 2) {
                        $('.html5-book .p2').addClass('fixed');
                    } else {
                        $('.html5-book .p2').removeClass('fixed');
                    }

                },

                turned: (e: Event) => {
                    $(e.target as Element).turn('center');
                },

                start: (e: Event, pageObj: JQuery) => {
                    const book = e.target as Element;
                    if (pageObj.page + 2 == $(book).turn('pages')) {
                        e.preventDefault();
                        return;
                    }
                }
            }
        });

    }

    private addRTLCss() {

        if (this.json.isRTL) {
            $("#flipbook .page").addClass("page-rtl");
            $(".flipbook-container").css("flex-direction", "row");
        } else {
            $("#flipbook .page").addClass("page-ltr")

        }
    }

    public mounted() {
        this.loadFlipbook(this.flipbookElement);
        window.addEventListener("resize", this.debounce(() => {
            this.reloadFlipbook(this.flipbookElement);
        }));

        this.flipbookElement.bind("turning", (event, page) => {
            if (page == 1) {
                // show first, hide second
                $(".second-arrow").addClass('arrow-hidden').removeClass('arrow-visible');
                $(".first-arrow").addClass('arrow-visible').removeClass('arrow-hidden');
            } else if (page + 3 >= this.flipbookElement.turn("pages")) {
                // hide first, show second
                $(".first-arrow").addClass('arrow-hidden').removeClass('arrow-visible');
                $(".second-arrow").addClass('arrow-visible').removeClass('arrow-hidden');
            } else {
                $(".first-arrow, .second-arrow").addClass('arrow-visible').removeClass('arrow-hidden');
            }

        });
        this.addRTLCss();
    }

    private static determineChunkSize(itemsCount: number) {
        const res = [];
        const possibleSizes = [8, 6, 4];
        const org = itemsCount;
        possibleSizes.sort(function (a, b) {
            return b - a
        });

        let i = 0;
        while (i < possibleSizes.length) {
            if (itemsCount / possibleSizes[i] >= 1) {
                res.push(possibleSizes[i]);
                itemsCount = itemsCount - possibleSizes[i];
                continue;
            }
            i++;
        }
        if (res.reduce((a, b) => a + b, 0) < org) {
            res.push(possibleSizes[possibleSizes.length - 1]);
        }
        return res;
    }


    private prepareChunks() {
        let i = 0, j = 0;

        const chunkSizes = AlbumComp.determineChunkSize(this.items.length);

        while (j < chunkSizes.length) {
            const temparray = this.items.slice(i, i + chunkSizes[j]);
            this.itemChunks.push({
                items:temparray,
                selected: temparray[0],
                index:this.itemChunks.length
            });
            i = i + chunkSizes[j];

            j++;
        }
    }

    private get depthImage() : string{
        return this.isRTL ? depthImageHe : depthImageEn;
    }
}
